import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-medal-line text-xl text-background-50"></i>
              </div>
              <div>
                <span className="text-lg font-bold text-background-50 font-heading">{siteInfo.name}</span>
              </div>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              {siteInfo.description.substring(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-background-100"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-background-100"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-background-100"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold text-background-50 mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">首页</Link></li>
              <li><Link to="/services" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">服务分类</Link></li>
              <li><Link to="/articles" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">体育资讯</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold text-background-50 mb-4 font-heading">服务项目</h4>
            <ul className="space-y-2.5">
              <li><Link to="/services?tab=events" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">体育赛事</Link></li>
              <li><Link to="/services?tab=training" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">运动培训</Link></li>
              <li><Link to="/services?tab=products" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">体育用品</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-background-100 transition-colors">企业团建</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold text-background-50 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.address}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-primary-400"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-time-line text-primary-400"></i>
                <span>周一至周五 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="container-custom py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | <a href="#" className="hover:text-background-100 transition-colors">京ICP备2024XXXXXXXX号</a>
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-100 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-100 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-100 transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}